var configs = require("../../public/config.json");

export const getDistance = (lat1, lon1, lat2, lon2) => {
  var distance = google.maps.geometry.spherical.computeDistanceBetween(
    new google.maps.LatLng(lat1, lon1),
    new google.maps.LatLng(lat2, lon2)
  );
  return distance;
};
